import React from "react";
import { Button } from "react-bootstrap";
import { utils, writeFile } from "xlsx";
import { deudasService } from "../../_services/deudas.service";
import { calcularMontoArray, formatCapital } from "../../utils/utils";
import { useDispatch } from "react-redux";
import { setLoading } from "../../redux/Loading/actions";

const DescargarExcel = ({ data, addDeuda, children, style=undefined }) => {
  const dispatch = useDispatch();

  async function exportData() {
    const { dataList, filename, name } = data;

    let deudas = addDeuda ? [] : dataList;

    if (addDeuda) {
      dispatch(setLoading(true));

      for (const e of dataList) {
        const resDeuda = await deudasService.getDeuda({
          imponible: e.INMUEBLE || e.IMPONIBLE,
          recurso: e.RECURSO
        });

        if (!resDeuda?.data || resDeuda?.data?.mensaje) {
          deudas.push(e);
          continue;
        }
        else {
          deudas.push({
            ...e,
            "DEUDA": `$ ${formatCapital(calcularMontoArray(resDeuda?.data?.deuda, "TOTAL"))}`,
            "CONTRIBUYENTE": resDeuda?.data?.contribuyente?.APYNOM
          });
          continue;
        }
      }

      dispatch(setLoading(false));
    }

    let ws = utils.json_to_sheet(deudas);
    let wb = utils.book_new();
    utils.book_append_sheet(wb, ws, name);
    await writeFile(wb, filename);
  }

  if (children) {
    return (
      <button
        style={style}
        onClick={exportData}
      >
        {children}
      </button>
    );
  }
  else {
    return (
      <Button className="custom-button" onClick={exportData} >
        Descargar Excel
      </Button>
    );
  }
};

export default DescargarExcel;
